import { LOADING, ActionSource, asUI } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { Clickable } from "../ui/deprecated/components";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const ClickableMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[childValue, onTap]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick } = useOnClickFromAction(onTap, ActionSource.Clickable, ctx, env);
    if (childValue === LOADING) return env.renderProgress();

    const child = asUI(childValue).render(ctx, env);

    if (onTap === LOADING) return child;

    return <Clickable onClick={onClick !== undefined ? () => onClick(undefined) : undefined}>{child}</Clickable>;
};
